import {
  ApolloClient,
  InMemoryCache,
  split,
  HttpLink,
  from,
  useMutation,
} from "@apollo/client";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { createClient } from "graphql-ws";
import { getMainDefinition } from "@apollo/client/utilities";
import { onError } from "@apollo/client/link/error";
import { setContext } from "@apollo/client/link/context";
import { baseURL, wsbaseURL } from "../config/config";
import toast from "react-hot-toast";
import { getRefreshToken } from "../Utils/Common";
import { LOGOUT } from "./Mutations";

// Implement cache configuration with type policies
// const cache = new InMemoryCache({
//   typePolicies: {
//     Query: {
//       fields: {
//         // Add field policies for pagination
//         messages: {
//           keyArgs: ["conversationId"],
//           merge(existing = [], incoming, { args }) {
//             return [...existing, ...incoming];
//           },
//         },
//       },
//     },
//   },
//   resultCaching: true,
//   possibleTypes: {} // Add your union and interface types here
// });

// Helper to check if a string is valid JSON
function isJSONString(str) {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
}

// ✅ Set token dynamically before each request
const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

// ✅ HTTP link
const httpLink = new HttpLink({
  uri: baseURL + "/workfreeli",
});

// ✅ WebSocket link
const wsLink = new GraphQLWsLink(
  createClient({
    url: wsbaseURL + "/graphql",
    connectionParams: () => {
      const token = localStorage.getItem("token");
      return {
        authToken: token ? `Bearer ${token}` : "",
      };
    },
  })
);

// const [common_res] = useMutation(LOGOUT);

// export const Logout = () => {

//   localStorage.clear();
//   window.location.href = "/login";  // redirect safely
// };

export const Logout = async (common_res) => {
  const xmpp_token = localStorage.getItem('xmpp_tokenid');
  const isTrusted = localStorage.getItem('isTrusted');

  const remove_device = isTrusted === 'yes' ? 'no' : 'yes';
  const final_remove_device = isTrusted ? remove_device : 'no';

  const res = await common_res({
    variables: {
      input: {
        remove_device: final_remove_device,
        xmpp_token: xmpp_token,
        device_type: 'web',
        fcm_token: window.firebase_token || '',
      },
    },
  });

  if (res?.data?.logout?.status) {
    localStorage.clear();
    window.location.href = "/login";
  }
};

// ✅ Error handling
const errorLink = onError(async ({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    const firstError = graphQLErrors[0];

    if (firstError.message.includes("jwt expired") || firstError.extensions?.code === "UNAUTHENTICATED") {
      // Token expired or unauthenticated
      // console.warn("Session expired. Logging out...");
      try {
        await getRefreshToken();
        window.location.reload();
      } catch (error) {
        console.log(error);
        Logout();
      }
      return; // Important: stop further execution
    }

    if (isJSONString(firstError.message)) {
      const parsed = JSON.parse(firstError.message);
      console.error("Parsed GraphQL Error:", parsed);
      // Optionally show toast or redirect based on parsed error
      toast.error(parsed?.message || "Something went wrong.");
    } else {
      toast.error(firstError.message);
    }

    // if (firstError.message === "Context creation failed: jwt expired") {
    //   try {
    //     window.location.reload();
    //   } catch (error) {
    //     console.log(error);
    //   }
    // } else {
    //   if (isJSONString(firstError.message)) {
    //     const parsed = JSON.parse(firstError.message);
    //     console.log("Parsed JSON error:", parsed);
    //     // You can redirect if needed
    //   } else {
    //     toast.error(firstError.message);
    //   }
    // }

    graphQLErrors.forEach(({ message, locations, path }) => {
      console.error(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      );
    });
  }

  if (networkError) {
    console.error(`[Network error]: ${networkError}`);
  }
});

// ✅ Split link: route subscription ops to wsLink, others to authLink + http
const splitLink = split(
  ({ query }) => {
    const def = getMainDefinition(query);
    return (
      def.kind === "OperationDefinition" &&
      def.operation === "subscription"
    );
  },
  wsLink,
  authLink.concat(httpLink)
);

// ✅ Final Apollo Client
const client = new ApolloClient({
  link: from([errorLink, splitLink]),
  cache: new InMemoryCache(),
});

export default client;
